/**
 * Serialize unknown values for logs, telemetry, and UI text without `[object Object]`.
 * Prefer this over `String(value)` when `value` may be a non-primitive.
 */
export function unknownToLogString(value: unknown, maxLen = 500): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') {
    return value.length > maxLen ? `${value.slice(0, maxLen)}…` : value;
  }
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  if (typeof value === 'bigint') return value.toString();
  if (typeof value === 'symbol') return value.toString();
  if (value instanceof Error) {
    const m = value.message;
    return m.length > maxLen ? `${m.slice(0, maxLen)}…` : m;
  }
  if (value instanceof Date) {
    const iso = value.toISOString();
    return iso.length > maxLen ? `${iso.slice(0, maxLen)}…` : iso;
  }
  if (typeof value === 'object') {
    try {
      const s = JSON.stringify(value);
      return s.length > maxLen ? `${s.slice(0, maxLen)}…` : s;
    } catch {
      return '[Unserializable]';
    }
  }
  return String(value);
}
